import { InputField } from "../AddPatientGroup.style";
import * as React from "react";
import { useTranslation } from "hhn-commons";
import { errorsType } from "../PatientGroupUtils";

type InputLastNameProps = {
  patientInfoData: any;
  onFormDataChange: (key: string, value: string) => void;
  onSetErrors: (key: string, value: boolean) => void;
  errors: errorsType;
};
export const InputLastName = ({
  patientInfoData,
  onFormDataChange,
  onSetErrors,
  errors,
}: InputLastNameProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });
  return (
    <InputField
      required
      id="last-name"
      label={tNs("lastNameLabel")}
      type="text"
      variant="standard"
      onBlur={e => {
        const lastName: string = e.target.value;
        onSetErrors("lastName", lastName.trim().length <= 0);
      }}
      error={errors.lastName}
      value={patientInfoData.lastName}
      onChange={e => {
        onFormDataChange("lastName", e.target.value);
        onSetErrors("lastName", e.target.value.trim().length <= 0);
      }}
      helperText={errors.lastName ? tNs("invalidLastName") : " "}
      slotProps={{
        inputLabel: { shrink: !!patientInfoData.lastName },
        htmlInput: {
          "data-testid": "last-name",
          maxLength: 25,
        },
      }}
    />
  );
};
